import React from 'react';
import accounting from 'accounting';
import restClientAutoo from './providers/restClientAutoo';
import { apiUrl } from './config';


export function morphAffix(num, f1, f2, f5) {
  let n = Math.abs(num) % 100;
  if (n > 10 && n < 20) {
    return f5;
  }
  n %= 10;
  if (n > 1 && n < 5) {
    return f2;
  }
  if (n === 1) {
    return f1;
  }
  return f5;
}

export function morph(num, f1, f2, f5) {
  return `${num} ${morphAffix(num, f1, f2, f5)}`;
}

export const formatMoney = sum => accounting.formatMoney(sum, {
  precision: 0,
  thousand: ' ',
  format: '%v'
});

export const formatRubMoney = sum => {
  const money = `${formatMoney(sum)} ₽`;
  if (sum >= 0) return money;
  return (<span style={{ color: '#dd3333' }}>{money}</span>);
};

export const formatPercentages = perc => {
  if (Number.isNaN(perc)) {
    return '0%';
  }
  return `${perc}%`;
};

export function goToPage(pageName) {
  if (!pageName) return;
  window.location.href = `/fa/#/${pageName}`;
}

export const aggregatePercentages = (array, field = 'ctr') => {
  const arrayLength = array.length;

  const result = array.reduce((accumulator, company) => accumulator + company[field], 0);
  return Math.floor(result / arrayLength);
};

export const aggregateSum = (array, field) => array.reduce(
  (accumulator, company) => accumulator + company[field],
  0
);

export const restClient = restClientAutoo(apiUrl);

export const hasAccess = (userRole, neededRoles) => neededRoles.some(role => userRole === role);

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

export const QCD_STATUSES = [
  {
    id: 'new', name: 'Новый', shortName: 'Новый', color: '#8f8f8f'
  },
  {
    id: 'inprogress', name: 'В работе', shortName: 'В раб.', color: '#9b69db'
  },
  {
    id: 'closed', name: 'Закрыт', shortName: 'Закрыт', color: '#35CD59'
  }
];

export const QCD_RESULTS = [
  {
    id: 'new', name: 'Новый', shortName: 'Новый', color: '#8f8f8f'
  },
  {
    id: 'good', name: 'Хорошо', shortName: 'Хорошо', color: '#35CD59'
  },
  {
    id: 'act_verified', name: 'Подтвержден', shortName: 'Подтв.', color: '#2c9bc3'
  },
  {
    id: 'noanswer', name: 'Недозвон', shortName: 'Недозв.', color: '#9b69db'
  },
  {
    id: 'negative', name: 'Негатив', shortName: 'Негатив', color: '#ac5252'
  },
  {
    id: 'toxic', name: 'Токсик', shortName: 'Токсик', color: '#ff0007'
  }
];

export const STATUSES = [
  {
    id: 'new', name: 'Новый', shortName: 'Новый', color: '#2c9bc3'
  },
  {
    id: 'rejected', name: 'Отказ', shortName: 'Отказ', color: '#8f8f8f'
  },
  {
    id: 'verified', name: 'Подтвержден', shortName: 'Подтв.', color: '#9b69db'
  },
  {
    id: 'noanswer', name: 'Недозвон', shortName: 'Недоз.', color: '#ac5252'
  },
  {
    id: 'visited', name: 'Пришел', shortName: 'Приш.', color: '#35CD59'
  },
];

export const VISITED = [
  {
    id: 'new', name: '-', color: '#8f8f8f'
  },
  {
    id: 'yes', name: 'Да', color: '#35CD59'
  },
  {
    id: 'no', name: 'Нет', color: '#8f8f8f'
  },
  {
    id: 'defect', name: 'Брак', color: '#ac5252'
  },
];

export const COMPANY_STATUS_NEW = [
  {
    id: 'enabled', name: 'Включено', shortName: 'Вкл.', color: '#67c35d'
  },
  {
    id: 'pause', name: 'Пауза', shortName: 'Пауза', color: '#8f890d'
  },
  {
    id: 'disabled', name: 'Выключено', shortName: 'Выкл.', color: '#ac5252'
  }
];

export const CALLCENTER_PLAN = [
  {
    id: 'outsource', name: 'Аутсорс', shortName: 'Аутсорс', color: '#2c9bc3'
  },
  {
    id: 'jurcall', name: 'Юркц', shortName: 'Юркц', color: '#8f6900'
  },
  {
    id: 'rent', name: 'Аренда', shortName: 'Аренда', color: '#9b69db'
  }
];

export const CALLCENTER_STATUS_NEW = [
  {
    id: 'enabled', name: 'Включено', shortName: 'Вкл.', color: '#67c35d'
  },
  {
    id: 'disabled', name: 'Выключено', shortName: 'Выкл.', color: '#ac5252'
  }
];

export const STATUSES_PAYMENT = [
  {
    id: 'new', name: 'Новый', shortName: 'Новый', color: '#2c9bc3'
  },
  {
    id: 'pay', name: 'Выполнен', shortName: 'Выполнен', color: '#35cd59'
  },
  {
    id: 'canceled', name: 'Отменен', shortName: 'Отменен', color: '#8f8f8f'
  }
];

export const addCounters = countersFunc => array => array.map(company => Object.assign(countersFunc(company), company));

export function getMonthRus(date) {
  const monthNumber = date.getMonth();

  switch (monthNumber) {
    case 0:
      return 'Янв';
    case 1:
      return 'Фев';
    case 2:
      return 'Мар';
    case 3:
      return 'Апр';
    case 4:
      return 'Май';
    case 5:
      return 'Июн';
    case 6:
      return 'Июл';
    case 7:
      return 'Авг';
    case 8:
      return 'Сен';
    case 9:
      return 'Окт';
    case 10:
      return 'Ноя';
    case 11:
      return 'Дек';
    default:
      return 'ххх';
  }
}

export function getDayRus(date) {
  const monthNumber = date.getUTCDay();

  switch (monthNumber) {
    case 0:
      return 'Пн';
    case 1:
      return 'Вт';
    case 2:
      return 'Ср';
    case 3:
      return 'Чт';
    case 4:
      return 'Пт';
    case 5:
      return 'Сб';
    case 6:
      return 'Вс';
    default:
      return 'хх';
  }
}

export function getDateString(date) {
  return `${date.getUTCDate()} ${getMonthRus(date)}`;
}

export function dateToHtmlInputDate(date) {
  return `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`;
}

export function dateToHtmlInputTime(date) {
  return `${(`0${date.getHours()}`).slice(-2)}:${(`0${date.getMinutes()}`).slice(-2)}`;
}

export function getDateByDayId(dayId, timeStartOrEnd = false) {
  const date = new Date();
  if (!timeStartOrEnd) {
    date.setHours(0, 0, 0, 0);
  } else {
    date.setHours(23, 59, 59, 999);
  }
  return new Date(date.getTime() + dayId * 24 * 60 * 60 * 1000);
}

export function dateIntervalsGenerator() {
  const array = [-51, -50, -49, -48, -47, -46, -45, -44, -43, -42, -41, -40, -39, -38, -37, -36, -35, -34, -33, -32, -31, -30, -29, -28, -27, -26, -25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8];
  return array.map((value, id) => ({
    key: id,
    from: getDateByDayId(value).toISOString(),
    to: getDateByDayId(value, true).toISOString(),
    name: getDateString(getDateByDayId(value, true)),
    count: 0
  }));
}

export const renderField = ({
  input, label, type, meta: { touched, error, warning }
}) => (
  <div>
    <input {...input} placeholder={label} type={type} />
    {touched && ((error && <span style={{ color: '#bd4040', fontSize: 12 }}>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

export const renderSelectField = ({ input, label, type, meta: { touched, error, warning }, children }) => (
  <div>
    <select {...input}>
      {children}
    </select>
    {touched && ((error && <span style={{ color: '#bd4040', fontSize: 12 }}>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

export const renderPhoneField = ({
  input, label, type, meta: { touched, error, warning }
}) => (
  <div>
    <div style={{
      display: 'flex', border: '1px solid rgb(216, 216, 216)', overflow: 'hidden', background: '#ffffff', borderRadius: '2px'
    }}
    >
      <span style={{
        flex: '0 0 auto', paddingRight: 0, width: 'auto', color: '#323232', fontFamily: 'Open Sans', fontSize: 12, fontWeight: 400, lineHeight: '2.1', paddingLeft: 8
      }}
      > +7
      </span>
      <input
        {...input}
        placeholder={label}
        type={type}
        style={{
          border: 'none', outline: 'none', boxShadow: 'none', borderRadius: 0, backgroundColor: 'transparent', flex: '1 1 auto', paddingLeft: 0
        }}
      />
    </div>
    {touched && ((error && <span style={{ color: '#bd4040', fontSize: 12 }}>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

export const required = value => value ? undefined : 'Обязательное поле';

export const phoneValidation = value => {
  if (!value) {
    return 'Укажите телефон';
  }
  const length = 11;
  const charset = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '(', ')', '-', ' '];
  for (const index in value) {
    if (charset.indexOf(value[index]) === -1) {
      return 'Недопустимые символы в телефоне';
    }
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length < length) {
    return 'Минимум 11 символов';
  }
  if (onlyNums.length > length) {
    return 'Максимум 11 символов';
  }
  return undefined;
};

export const nameValidation = value => {
  if (!value) {
    return 'Укажите имя';
  }
  const charset = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя ';
  for (const index in value) {
    if (charset.indexOf(value[index]) === -1) {
      return 'Недопустимые символы в имени';
    }
  }
  if (value.length < 2) {
    return 'Минимум 2 символа';
  }
  return undefined;
};

export const nameValidation2 = value => {
  if (!value) {
    return 'Укажите название';
  }
  const charset = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя1234567890()-/ ';
  for (const index in value) {
    if (charset.indexOf(value[index]) === -1) {
      return 'Недопустимые символы в названии';
    }
  }
  if (value.length < 2) {
    return 'Минимум 2 символа';
  }
  return undefined;
};

export const nameValidation3 = value => {
  if (!value) {
    return 'Укажите аббревиатуру';
  }
  const charset = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя1234567890 ';
  for (const index in value) {
    if (charset.indexOf(value[index]) === -1) {
      return 'Недопустимые символы';
    }
  }
  if (value.length < 3) {
    return 'Минимум 3 символа';
  }

  if (value.length > 4) {
    return 'Максимум 4 символа';
  }
  return undefined;
};

export const normalizePhone = (value) => {
  // console.log('normalize='+value);
  const result = `7${value}`;
  // console.log('normalizeResult='+result);
  return result;
};

export const formatPhone = (value) => {
  // console.log('format='+value);
  if (!value) return '';
  const result = value.substr(1, value.length - 1);
  // console.log('formatResult='+result);
  return result;
};



// WEBPACK FOOTER //
// ./src/common.js